import { useCallback, useEffect, useState } from 'react';
import Questions from '../components/questions';
import Menu from '../components/menu';
import { ITest } from '../data/interfaces';

type Props = {
  test: ITest;
};

export default ({ test }: Props) => {
  const [examFinished, setExamFinished] = useState(false);

  const [successTotal, setSuccessTotal] = useState(0);
  const [successLanguageCount, setSuccessLanguageCount] = useState(0);
  const [successHistoryCount, setSuccessHistoryCount] = useState(0);
  const [successLawCount, setSuccessLawCount] = useState(0);

  const [failTotal, setFailTotal] = useState(0);
  const [failLanguageCount, setFailLanguageCount] = useState(0);
  const [failHistoryCount, setFailHistoryCount] = useState(0);
  const [failLawCount, setFailLawCount] = useState(0);

  const alertSuccess = () => {
    alert('Congratulations! You have successfully passed the exam!');
  };

  const alertFail = (reason: string) => {
    const msg = "Unfortunately you haven't passed the exam";

    switch (reason) {
      case 'language':
        alert(`${msg}. Failed Georgian Language.`);
        break;
      case 'history':
        alert(`${msg}. Failed History of Georgia.`);
        break;
      case 'law':
        alert(`${msg}. Failed Fundamentals of Law.`);
        break;
      case 'timer':
        alert(`${msg}. Time's out.`);
        break;
      default:
        break;
    }
  };

  const setSuccess = () => {
    if (
      successLanguageCount >= 7 &&
      successHistoryCount >= 7 &&
      successLawCount >= 7
    ) {
      setExamFinished(true);
      alertSuccess();
    }
  };

  const setFail = () => {
    let category;
    if (failLanguageCount > 3) {
      category = 'language';
    } else if (failHistoryCount > 3) {
      category = 'history';
    } else if (failLawCount > 3) {
      category = 'law';
    }

    if (category) {
      setExamFinished(true);
      alertFail(category);
    }
  };

  const handleTimeOut = () => {
    setExamFinished(true);
    alertFail('timer');
  };

  useEffect(() => {
    setSuccess();
    setSuccessTotal(
      successLanguageCount + successHistoryCount + successLawCount
    );
    setFail();
    setFailTotal(failLanguageCount + failHistoryCount + failLawCount);
  }, [
    successLanguageCount,
    failLanguageCount,
    successHistoryCount,
    failHistoryCount,
    successLawCount,
    failLawCount,
  ]);

  const incrementResult = useCallback((category: string, success: boolean) => {
    switch (category) {
      case 'language':
        if (success) {
          setSuccessLanguageCount((v) => v + 1);
        } else {
          setFailLanguageCount((v) => v + 1);
        }
        break;
      case 'history':
        if (success) {
          setSuccessHistoryCount((v) => v + 1);
        } else {
          setFailHistoryCount((v) => v + 1);
        }
        break;
      case 'law':
        if (success) {
          setSuccessLawCount((v) => v + 1);
        } else {
          setFailLawCount((v) => v + 1);
        }
        break;
      default:
        break;
    }
  }, []);

  const categories = Object.keys(test).map((category: string) => {
    return (
      <div>
        <h2 className="category">
          {category.charAt(0).toUpperCase() + category.slice(1)}
        </h2>
        <Questions
          category={category}
          questions={test.getQuestions(category)}
          examFinished={examFinished}
          hasAnswer={false}
          incrementResult={incrementResult}
        />
      </div>
    );
  });

  return (
    <div>
      <Menu
        isSimulation
        successTotal={successTotal}
        failTotal={failTotal}
        examFinished={examFinished}
        pageTitle="Exam simulation"
        setTimeOut={handleTimeOut}
      />
      <div className="main">
        <div className="main-content">{categories}</div>
      </div>
    </div>
  );
};
